export default {"src":"/_next/static/media/link-icon.7869c879.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};